export default __webpack_public_path__ + "static/media/patient2.a0c0c454.jpeg";